/* eslint-disable */
// Dependency imports
import clsx from 'clsx';
import { List, ListItem, styled, ListItemButton } from '@mui/material';
import React, { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Local imports
import { RootState } from '../../store';
import routes from 'routes/privateRoutesConfig';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { setPreventNavigation } from 'store/preventNavigation/preventNavigationSlice';

const AppMenu: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profile = useSelector((state: RootState) => state.auth.profile);
  const preventNavigation = useSelector(
    (state: RootState) => state.preventNavigation.preventNavigation
  );

  const [openIndex, setOpenIndex] = useState<number | null>(() => {
    let opened = null;
    Object.keys(routes).forEach((key, index) => {
      const item = routes[key];
      Object.keys(item?.items || {}).forEach((key, idx) => {
        const subItem = (item?.items || {})[key];

        if (location.pathname.includes(subItem.route || '')) {
          opened = index;
        }
      });
    });
    return opened;
  });

  return (
    <div className="w-[8%] h-[92vh] bg-[#102533] mt-[4px]">
      <div className="w-full text-white">
        {Object.keys(routes).map((key, index) => {
          const item = routes[key];
          const isOpened = openIndex === index;
          const path = item.route || '';
          const active =
            location.pathname === path || location?.pathname.startsWith(path);
          return (
            <div key={index}>
              {!(
                profile?.organization?.id ===
                  '2695594a-87fd-4431-8219-14d2f453e2c2' &&
                item?.name === 'Inference'
              ) && (
                <div
                  key={`app-menu-${index}`}
                  onClick={() => setOpenIndex(isOpened ? null : index)}
                  // active={
                  //   location.pathname === path ||
                  //   location?.pathname.startsWith(path)
                  // }
                  className={clsx(
                    'h-[6vh] border-b-[2px] flex items-center justify-start cursor-pointer text-[0.8vw] hover:text-[0.9vw]',
                    active && 'bg-[#EEEEEE] text-[#102533] text-[0.9vw]'
                  )}
                  {...(!item?.items && {
                    onClick: () => {
                      if (preventNavigation) {
                        Swal.fire({
                          title: 'Warning: Ongoing Process!!',
                          icon: 'warning',
                          html: `
                         Changing or Refreshing the page will result in losing your data!
                        `,
                          // text: 'Are you sure you want to leave?',
                          allowOutsideClick: false,
                          confirmButtonText: 'Leave!',
                          showCancelButton: true,
                          confirmButtonColor: '#E33030',
                          cancelButtonColor: '#102633',
                          cancelButtonText: 'Cancel!',
                          focusCancel: true,
                          animation: true,
                          customClass: {
                            title: 'swal2-title2',
                            container: 'swal2-html-cont2',
                            actions: 'swal2-actions2',
                            htmlContainer: 'swal2-html'
                          }
                        }).then(async result => {
                          if (result.isConfirmed) {
                            dispatch(setPreventNavigation(false));
                            item.route && navigate(item.route);
                          }
                        });
                      } else {
                        item.route && navigate(item.route);
                      }
                    }
                  })}
                >
                  <p className="ml-2">{item.name}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default AppMenu;
